import { render } from "./TabDocuments.vue?vue&type=template&id=33e9ceb0&scoped=true"
import script from "./TabDocuments.vue?vue&type=script&lang=js"
export * from "./TabDocuments.vue?vue&type=script&lang=js"

import "./TabDocuments.vue?vue&type=style&index=0&id=33e9ceb0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e9ceb0"]])

export default __exports__